module.exports = __webpack_public_path__ + "img/letter.108ae820.svg";